import { Node, mergeAttributes } from "@tiptap/core"

import {
  DIAGRAM_DATA_ATTR,
  DIAGRAM_DISPLAY_STYLE,
  isDiagramContentType,
} from "../utils/diagramConstants"
import {
  diagramAttrsFromElement,
  renderDiagramHtmlAttributes,
} from "../utils/diagramNodeAttrs"

export const DiagramNode = Node.create({
  name: "diagram",
  group: "block",
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      src: { default: null },
      diagramXml: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute(DIAGRAM_DATA_ATTR.diagramXml),
        renderHTML: (attributes) => {
          if (!attributes.diagramXml) return {}
          return { [DIAGRAM_DATA_ATTR.diagramXml]: attributes.diagramXml }
        },
      },
      contentType: {
        default: "geometry",
        parseHTML: (element) =>
          element.getAttribute(DIAGRAM_DATA_ATTR.contentType),
        renderHTML: (attributes) => ({
          [DIAGRAM_DATA_ATTR.contentType]: attributes.contentType,
        }),
      },
      alt: { default: null },
      style: {
        default: DIAGRAM_DISPLAY_STYLE,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => {
          if (!attributes.style) return {}
          return { style: attributes.style }
        },
      },
      width: { default: null },
      height: { default: null },
    }
  },

  parseHTML() {
    return [
      {
        tag: `img[${DIAGRAM_DATA_ATTR.contentType}]`,
        getAttrs: (element) => {
          if (!(element instanceof HTMLElement)) return false
          return diagramAttrsFromElement(element)
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const contentType = HTMLAttributes.contentType
    if (!isDiagramContentType(contentType) || !HTMLAttributes.src) {
      return ["img", mergeAttributes(HTMLAttributes)]
    }

    return [
      "img",
      mergeAttributes(
        renderDiagramHtmlAttributes({
          src: HTMLAttributes.src,
          diagramXml: HTMLAttributes.diagramXml ?? "",
          contentType,
          alt: HTMLAttributes.alt ?? "",
          style: HTMLAttributes.style ?? DIAGRAM_DISPLAY_STYLE,
          width: HTMLAttributes.width ?? null,
          height: HTMLAttributes.height ?? null,
        })
      ),
    ]
  },
})

export default DiagramNode
